import axios from 'axios'

export default axios.create({
  baseURL: 'https://zhengdaolishanghu.com/laravel/api/',

  // baseURL:'http://localhost:8000/api'
  // baseURL:'http://sd6webdev.indomaret.lan:8181/Taoyu/laravel-passport/public/api'
  // baseURL:'http://sd6webdev.indomaret.lan/Taoyu/laravel-passport/public/api'
   //baseURL:'http://sd6webdev.indomaret.lan/laravel-passport/public/api/'
})

// const instance = axios.create({
//    baseURL: 'http://sd6webdev.indomaret.lan/proposalto/public/api/',
// });
//instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;
